export default "__VITE_ASSET__Cxzm6sRs__"